import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { DOC_LINKS_V2 } from 'shared/consts/DockLinks';

import { RootState } from 'store/rootReducer';

const TermsAndCondition = () => {
	const { t }: any = useTranslation(['common']);

	const termOfUse = useSelector((state: RootState) => state.User.botAdmin.data.term_of_use);

	return (
		<li>
			<a
				className='account-dropdown-menu__link-item'
				href={termOfUse && termOfUse !== 'NA' ? termOfUse : DOC_LINKS_V2.termOfUse}
				target='_blank'
				rel='noreferrer'
			>
				{t('common:terms')}
			</a>
		</li>
	);
};

export default TermsAndCondition;
